import styled from 'styled-components';
import { Loading } from 'components/Loading';

export const StyledLoading = styled(Loading)`
  margin: 30px auto 0 auto;
`;

export const StyledNotFound = styled.div`
  text-align: center;
`;
